<template>
  <div>
    <div class="decoration decoration-1"></div>
    <div class="decoration decoration-2"></div>

    <div class="container">
      <div class="header">
        <h1>天禄云枢古籍数据库</h1>
        <p>服务协议与隐私政策</p>
      </div>

      <div class="content">
        <!-- 网站服务协议部分 -->
        <div class="section">
          <h2 class="section-title">一、网站服务协议</h2>

          <div class="subsection">
            <h3 class="subsection-title">1. 导言</h3>
            <div class="subsection-content">
              <p>欢迎您使用天禄云枢古籍数据库（以下简称"天禄云枢"）及相关服务！</p>
              <p>本协议是用户（以下简称"您"）与天禄云枢的运营方（以下简称"我们"）之间的法律协议，规定了您在访问、注册、使用天禄云枢服务时的权利与义务。请您在使用本网站前仔细阅读并同意本协议。</p>
              <p>如您未满18周岁，请在法定监护人的陪同下阅读并理解本协议，并在取得监护人同意后使用天禄云枢。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">2. 账号注册与管理</h3>
            <div class="subsection-content">
              <p>您可使用手机号、邮箱等方式注册天禄云枢账号，并需提供真实、有效的身份信息。</p>
              <p>账号仅限本人使用，不得转让、出售或出借。</p>
              <p>若发现账号被盗用或出现安全风险，您应立即通知我们，我们将协助处理。</p>
              <p>账号密码是保障您账户安全的关键，请妥善保管，不要与他人分享。</p>
              <p>若账号长期未使用，我们可能会采取停用措施，以保障用户信息安全。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">3. 使用规则</h3>
            <div class="subsection-content">
              <p>您不得利用天禄云枢从事任何违法或违反公序良俗的行为。</p>
              <p>禁止未经许可爬取、复制、修改、传播或商业化利用天禄云枢的数据。</p>
              <p>用户不得通过非正常手段获取网站上的内容，如恶意攻击、破解技术等。</p>
              <p>违反本协议的行为，我们有权暂停或终止您的账号，并依法追究责任。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">4. 知识产权</h3>
            <div class="subsection-content">
              <p>天禄云枢提供的所有内容（包括但不限于文本、图片、数据库、软件代码）受版权保护，未经授权不得使用。</p>
              <p>用户上传的内容应为原创或已获得合法授权，不得侵犯第三方权益，否则用户需承担全部法律责任。</p>
              <p>网站内容仅供个人学习和研究使用，不得用于商业用途。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">5. 责任限制</h3>
            <div class="subsection-content">
              <p>我们将尽力确保服务的稳定性和安全性，但不对因不可抗力、系统故障等原因导致的服务中断或数据损失承担责任。</p>
              <p>由于网络环境和技术限制，我们无法保证所有数据的绝对安全，但我们承诺采取合理措施保障用户数据。</p>
              <p>对因您自身行为（如共享账户信息）造成的法律责任，您应自行承担。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">6. 服务变更与终止</h3>
            <div class="subsection-content">
              <p>我们可能会根据运营需求调整或终止部分服务，并会提前通知用户。</p>
              <p>若您长时间未使用账号，我们有权回收账号。</p>
              <p>若网站因业务调整或不可抗力导致无法继续运营，我们将提前通知并采取合理措施保障用户权益。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">7. 法律适用与争议解决</h3>
            <div class="subsection-content">
              <p>本协议适用中华人民共和国法律。</p>
              <p>任何争议应友好协商解决，协商不成的，提交天禄云枢运营方所在地有管辖权的法院裁决。</p>
            </div>
          </div>
        </div>

        <!-- 隐私政策部分 -->
        <div class="section">
          <h2 class="section-title">二、隐私政策</h2>

          <div class="subsection">
            <h3 class="subsection-title">1. 信息收集与使用</h3>
            <div class="subsection-content">
              <p>我们可能收集以下信息，以向您提供更优质的服务：</p>
              <p>账户信息：手机号、昵称、邮箱等。</p>
              <p>设备与日志信息：包括 IP 地址、浏览记录、搜索记录、收藏记录等。</p>
              <p>支付信息：购买内容时需提供支付相关信息，支付由第三方机构处理。</p>
              <p>客户支持信息：您提交的反馈、问题咨询等。</p>
              <p>社交互动信息：当您使用社交功能（如评论、点赞）时，我们可能会收集相关记录。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">2. 信息共享与披露</h3>
            <div class="subsection-content">
              <p>我们不会向任何第三方出售或共享您的个人信息，除非：</p>
              <p>法律要求：政府机构要求提供的信息。</p>
              <p>业务合作：向支付机构、物流公司等必要合作方提供信息。</p>
              <p>安全保障：检测、防范欺诈或安全威胁。</p>
              <p>统计分析：我们可能使用去标识化的数据进行统计分析，以优化产品体验。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">3. Cookie 与同类技术</h3>
            <div class="subsection-content">
              <p>我们可能使用 Cookie 记录您的偏好，提升服务体验。</p>
              <p>您可以通过浏览器设置禁用 Cookie，但部分功能可能受限。</p>
              <p>第三方广告和分析服务可能使用 Cookie 收集您的匿名使用数据。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">4. 数据存储与安全</h3>
            <div class="subsection-content">
              <p>我们将在境内存储您的个人信息，并采取加密、访问控制等安全措施保护您的数据。</p>
              <p>当您的账号长期不使用或注销时，我们会对数据进行删除或匿名化处理。</p>
              <p>发生数据泄露等安全事件时，我们将第一时间通知受影响用户，并采取补救措施。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">5. 未成年人保护</h3>
            <div class="subsection-content">
              <p>若您未满 18 周岁，应在监护人同意后使用本网站。</p>
              <p>我们不会主动收集未满 14 周岁儿童的个人信息，如发现误收集，将立即删除。</p>
              <p>监护人应指导未成年人合理使用互联网，并避免沉迷。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">6. 权利与选择</h3>
            <div class="subsection-content">
              <p>您可以：</p>
              <p>访问与更正信息：在个人中心修改个人信息。</p>
              <p>撤回授权：在法律允许的范围内，您可以撤回授权。</p>
              <p>删除账号：可申请注销账号，我们将在 15 个工作日内处理。</p>
              <p>下载数据：如有需要，您可以申请导出个人数据。</p>
            </div>
          </div>

          <div class="subsection">
            <h3 class="subsection-title">7. 隐私政策更新</h3>
            <div class="subsection-content">
              <p>本隐私政策可能会不时更新，重大变更时，我们将通过网站公告等方式通知您。</p>
              <p>若您继续使用天禄云枢，即视为同意更新后的隐私政策。</p>
            </div>
          </div>
          <div class="subsection">
            <h3 class="subsection-title">8. 联系方式</h3>
            <div class="subsection-content">
              <p>如您对本协议或隐私政策有任何疑问，可通过 <span class="highlight">tianluys@yeah.net</span> 邮件联系我们，我们将在 15 个工作日内回复。</p>
              <p>本协议与隐私政策自发布之日起生效，如您继续使用天禄云枢，即视为接受本协议与隐私政策的全部条款。</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "agreement",
};
</script>

<style lang="less" scoped>
    .container {
      max-width: 1000px;
      margin: 0 auto;
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
      overflow: hidden;
    }

    .header {
      text-align: center;
      padding: 40px 20px;
      margin-bottom: 20px;
      //background: linear-gradient(135deg, #2c3e50 0%, #4a6572 100%);
      //color: white;
    }

    .header h1 {
      font-size: 2.5rem;
      margin-bottom: 10px;
      text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
    }

    .header p {
      font-size: 2rem;
      opacity: 0.9;
      text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
      margin-bottom: 10px;
    }

    .content {
      padding: 40px;
    }

    .section {
      margin-bottom: 40px;
      padding-bottom: 30px;
      border-bottom: 1px solid #eaeaea;
    }

    .section:last-child {
      border-bottom: none;
    }

    .section-title {
      font-size: 1.8rem;
      color: #2c3e50;
      margin-bottom: 25px;
      padding-bottom: 10px;
      border-bottom: 2px solid #8e9eab;
    }

    .subsection {
      margin-bottom: 25px;
    }

    .subsection-title {
      font-size: 1.3rem;
      color: #4a6572;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
    }

    .subsection-title:before {
      content: "";
      display: inline-block;
      width: 8px;
      height: 8px;
      background: #8e9eab;
      border-radius: 50%;
      margin-right: 10px;
    }

    .subsection-content {
      color: #555;
      padding-left: 18px;
    }

    .subsection-content p {
      margin-bottom: 12px;
      text-align: justify;
    }

    .highlight {
      color: #2c3e50;
      font-weight: 600;
    }

    .contact-info {
      background: #f8f9fa;
      padding: 25px;
      border-radius: 8px;
      margin-top: 30px;
      border-left: 4px solid #4a6572;
    }

    .footer {
      text-align: center;
      padding: 25px;
      background: #2c3e50;
      color: #fff;
      font-size: 0.9rem;
    }

    @media (max-width: 768px) {
      .content {
        padding: 20px;
      }

      .header h1 {
        font-size: 2rem;
      }

      .section-title {
        font-size: 1.5rem;
      }

      .subsection-title {
        font-size: 1.1rem;
      }
    }

    /* 装饰元素 */
    .decoration {
      position: absolute;
      width: 200px;
      height: 200px;
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><path fill="%238e9eab" opacity="0.2" d="M50,0 L100,50 L50,100 L0,50 Z"></path></svg>');
      background-size: contain;
      opacity: 0.1;
      z-index: -1;
    }

    .decoration-1 {
      top: 10%;
      left: 5%;
    }

    .decoration-2 {
      bottom: 10%;
      right: 5%;
      transform: rotate(45deg);
    }
</style>



// WEBPACK FOOTER //
// src/view/agreement.vue